// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"394":"99296e73","485":"99296e73","571":"99296e73","610":"99296e73","636":"99296e73","691":"99296e73","934":"99296e73"}[chunkId] + ".chunk.css";
};